<div class="page-parent">
    <div class="page-parent-div">
        <div [innerHTML]="source"></div>
    </div>
</div>
